<template>
  <section class="content">
    <div class="row center-block">
      <div class="box">
  
  
        <div class="loadingContainer" v-if="showLoading">
          <i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw loading"></i>
        </div>
  
  
        <div class="dataTables_wrapper form-inline dt-bootstrap" id="example1_wrapper" v-if="showTable">
  
          <div class="row box-body">
            <div class="col-sm-12 table-responsive" id="Feedbacks">
  
              <table aria-describedby="example1_info" role="grid" id="example" style="width:100%" class="display table table-bordered table-striped dataTable wrap">
                <thead>
                  <tr role="row">
                    <!-- <th></th> -->
                    <th>Name</th>
                    <th>Mobile</th>
                    <th style="text-align:center;">Checkpoint</th>
                     <th style="text-align:center;">Category</th>
                    <th style="text-align:center;">Timestamp</th>
                    <th style="text-align:center;">Scanned By</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="even" role="row" v-for="(S,index) in List" style="text-align:center;">
                    <!-- <td class="sorting_1">{{index+1}}</td> -->
                    <td class="sorting_1">{{S.rsvpId.customFields.rsvpInfo.name}}</td>
                    <td class="sorting_1">{{S.rsvpId.customFields.rsvpInfo.mobile}}</td>
                    <td class="sorting_1"> {{ capitalizeFirstLetter(S.checkpoint) }} </td>
                    <td class="sorting_1"> {{ capitalizeFirstLetter(S.rsvpId.customFields.rsvpInfo.category) }} </td>
                    <td class="sorting_1">{{S.date | formatDate}}</td>
                    <td class="sorting_1">{{S.checkpointId.name}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- /.box-body -->
      </div>
  
  
    </div>
    </div>
  </section>
  </template>
  
  <script>
  
  import $ from 'jquery';
  import moment from 'moment';
  import axios from 'axios';
  import {
    globalStore
  } from '../../main.js';
  
  import Swal from 'sweetalert2';
  
  // Require needed datatables modules
  require('datatables.net')
  require('datatables.net-bs')
  
  export default {
    components: {
  
    },
    data() {
      return {
        showLoading: true,
        showTable: false,
        List: []
      }
    },
    mounted() {
  
      console.log("Scanner History Component Loaded...");
      console.log("URL: "+globalStore.url);
      console.log("clientId: "+globalStore.clientId);
      console.log("eventId: "+globalStore.eventId);
  
      this.getAll();
  
    },
    methods: {
      capitalizeFirstLetter(str) {
          if (!str) return ''; // Return empty string if the input is empty
            return str.charAt(0).toUpperCase() + str.slice(1);
      },
      getAll(){
        console.log("Get Access Logs");
  
        axios.get(
          globalStore.url+ `/api/accesslogs-eventId/`+globalStore.eventId
          ).then(response => {
            console.log("Get All AccessLogs API Response");
  
            console.log(response)
  
            this.List = response.data;
            // console.log(this.List);
            console.log("Access Logs: "+this.List.length)
            this.showLoading = false;
            this.showTable = true;
  
  
            setTimeout(() => {
              this.DisplayTable();
            }, 500);
  
  
          }).catch(e => {
            alert(e);
            console.log("Error :"+JSON.stringify(e));
          });
  
  
      },
      DisplayTable() {
        setTimeout(() => {
          this.$nextTick(() => {
  
            let table = $('#example').DataTable({
              // ajax: this.Feedbacks,
              // dom: 'Blfrtip',
              // orderCellsTop: true,
              // ordering:false,
              // fixedHeader: {
              //   // header: true,
              //   footer: true
              // },
              fixedColumns: true,
              autoWidth: true,
              buttons: [{
                extend: 'csvHtml5',
                text: 'Export To Excel',
                title: 'AccessLogs'
              }]
            });
  
  
            // Setup - add a text input to each footer cell
            // $('#example thead tr').clone(true).appendTo('#example thead');
            // $('#example thead tr:eq(1) th').each(function(i) {
            //   var title = $(this).text();
            //   $(this).html('<input type="text" placeholder="Search ' + title + '" />');
            //
            //   $('input', this).on('keyup change', function() {
            //     if (table.column(i).search() !== this.value) {
            //       table
            //         .column(i)
            //         .search(this.value)
            //         .draw();
            //     }
            //   });
            // });
            this.isLoading = false
          })
        }, 100)
      }
    }
  }
  </script>
  
  <style>
  .btn-warning,
  .btn-danger {
    width: 5em;
  }
  
  .Arrived{
    color: #46B996;
    font-weight: bold;
  }
  
  .notArrived{
    color: #EB455A;
    font-weight: bold;
  }
  
  .btn-outline-danger{
    background-color: #ffffff;
    border: 1px solid red;
    color: red;
  }
  
  .btn-outline-danger:focus{
    background-color: red;
    border: 1px solid red;
    color: #ffffff;
  }
  
  .lds-ripple {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
  }
  
  .lds-ripple div {
    position: absolute;
    border: 4px solid #fff;
    opacity: 1;
    border-radius: 50%;
    animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
  }
  
  .editor {
    /* height: 300px; */
    border-style: solid;
    border-width: 1px;
  }
  
  .editormenu {
    border-bottom: 1px solid;
  }
  
  .lds-ripple div:nth-child(2) {
    animation-delay: -0.5s;
  }
  
  .buttoncolor {
    color: black;
    background-color: white;
    -webkit-transition-duration: 0.4s; /* Safari */
    transition-duration: 0.4s;
  }
  .buttoncolor:hover {/* Green */
    background-color: #4CAF50; /* Green */
    color: white;
  }
  @keyframes lds-ripple {
    0% {
      top: 36px;
      left: 36px;
      width: 0;
      height: 0;
      opacity: 1;
    }
  
    100% {
      top: 0px;
      left: 0px;
      width: 72px;
      height: 72px;
      opacity: 0;
    }
  }
  
  .timeline-footer a.btn {
    margin-right: 10px;
  }
  
  .modal-title {
    color: #000000;
  }
  
  tfoot input {
    width: 10%;
    padding: 3px;
    box-sizing: border-box;
  }
  </style>
  


// WEBPACK FOOTER //
// AccessLogs.vue?d91349ea